import React from "react";
import { ChevronUp, ChevronDown } from "lucide-react";

/**
 * RowReorderControls (SOUND-506) — shared ⌃/⌄ up/down buttons for intake-field
 * and flow-step rows. No dnd library in the repo; up/down is the honest,
 * fully keyboard-accessible pattern. Ends are disabled.
 */
export default function RowReorderControls({ onUp, onDown, isFirst, isLast }) {
  return (
    <div className="flex shrink-0 flex-col">
      <button
        type="button"
        onClick={onUp}
        disabled={isFirst}
        className="btn btn-ghost h-6 w-6 p-0 disabled:opacity-30"
        aria-label="Move up"
      >
        <ChevronUp className="h-4 w-4" />
      </button>
      <button
        type="button"
        onClick={onDown}
        disabled={isLast}
        className="btn btn-ghost h-6 w-6 p-0 disabled:opacity-30"
        aria-label="Move down"
      >
        <ChevronDown className="h-4 w-4" />
      </button>
    </div>
  );
}
